import { useEffect, useRef } from 'react'
import { message as $message } from 'antd'
import { getUUID } from 'gyl-common/utils/uuid'
import { createMessageChannel } from '../../core/parent'

export default ({ name, origin }) => {
    const nameRef = useRef(name)
    const messageChannelRef = useRef(null)

    if (!nameRef.current) {
        nameRef.current = getUUID()
    }

    if (!messageChannelRef.current) {
        messageChannelRef.current = createMessageChannel({
            origin,
            namespace: nameRef.current
        })
    }

    useEffect(() => {
        let hide = null

        const messageMap = {
            'global/message:success': content => {
                $message.success(content)
            },
            'global/message:error': content => {
                $message.error(content)
            },
            'global/loading:show': content => {
                hide = $message.loading(content)
            },
            'global/loading:hide': () => {
                if (hide) {
                    hide()
                    hide = null
                }
            }
        }

        Object.keys(messageMap).forEach(v => {
            messageChannelRef.current.receiveMessage(v, messageMap[v])
        })

        return () => {
            Object.keys(messageMap).forEach(v => {
                messageChannelRef.current.removeListen(v, messageMap[v])
            })
        }
    }, [messageChannelRef.current])

    useEffect(() => {
        return () => {
            messageChannelRef.current.close()
        }
    }, [])

    return {
        name: nameRef.current,
        messageChannel: messageChannelRef.current
    }
}
